
import React, { useEffect } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";
import { useFormValidation } from "../../hooks/formHooks";
import { getPaymentsForm } from "../../forms/SettingsForm";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentOrganization, selectOrganizationBankAccount, getOrgBankAccount, selectOrganizationNotifications, clearNotifications, setOrganizationNotifications } from "../../reducers/organizationSlice";

//import scss
import "./organization-settings-payments.scss"
import { getNotificationItemInfo } from "../../helpers/Converters";
import { useNotificationBanner } from "../../hooks/notificationHooks";

//Name the component
const OrganizationSettingsPayments = () => {
  const [context] = useFormValidation(false)
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const selectedBankAccount = useSelector(selectOrganizationBankAccount);
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const matchEdit = useMatch("/:id/settings/payments");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (matchEdit?.params?.id) {
      dispatch(getOrgBankAccount(matchEdit?.params?.id));
    }
  }, [dispatch, matchEdit?.params?.id]);

  context.connectStripe = () => {
    let clientId = process.env.REACT_APP_STRIPE_CLIENT_ID;
    let state = selectedOrganization?.id ;
    let uri = responseUri();

    window.open(`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${clientId}&scope=read_write&redirect_uri=${uri}&state=${state}`);
  }

  context.removeStripeAccount = () => {
    if (selectedOrganization?.stripeId) {
      navigate('disconnect-stripe-account');
    }
  }

  context.connectBankAccount = () => {
    if (selectedOrganization?.stripeId) {
      // throw up error banner
      dispatch(setOrganizationNotifications([removeStripeBanner()]));
    } else {
      navigate('add-bank-account');
    }
  }

  context.removeBankAccount = () => {
    navigate('remove-bank-account');
  }

  context.verifyBankAccount = () => {
    navigate('verify-bank-account');
  }

  const responseUri = () => `${process.env.REACT_APP_GOLFSTATUS_ORGANIZATIONS_URL}/stripe-account-connected`;

  const removeStripeBanner = () => {
    const headerText = "Account Already Connected";
    const bannerText = "To add a new account, disconnect the existing one.";
    return {
      header: getNotificationItemInfo(bannerText, faExclamationCircle, headerText),
      state: "warning",
      bannerActions: [
        {
          title: "Disconnect Account",
          type: "secondary",
          actionClick: () => {
            dispatch(clearNotifications());
            context.removeStripeAccount();
          }
        },
      ],
    };
  };

  const verifyAccountBanner = () => {
    const headerText = "Bank Account Pending";
    const bannerText = "Two small deposits will be made in this account within 1-3 business days. Use those amounts to verify your account.";
    return {
      title: getNotificationItemInfo(bannerText, faExclamationCircle, headerText),
      state: "grey",
      bannerActions: [
        {
          title: "Verify Account",
          type: "secondary",
          actionClick: () => {
            dispatch(clearNotifications());
            context.verifyBankAccount();
          }
        },
      ],
    };
  };

  const leftNavigation = () => {
    dispatch(clearNotifications());
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Payment Settings`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return <GSForm formTitle="Payment Settings" formSections={getPaymentsForm(context, selectedOrganization, selectedBankAccount)}></GSForm>;
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({
    notifications: orgNotifications,
    defaultBanner: selectedBankAccount?.status === 'pending' ? verifyAccountBanner() : false,
    timeoutAction,
  });

  return (
    //name the component tag
    <organization-settings-payments>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
      ></GSSidePanelPage>
    </organization-settings-payments>
  );
};

//export it
export default OrganizationSettingsPayments;